import React from 'react';
import styles from './MessageBubble.module.css';

interface MessageBubbleProps {
  children: React.ReactNode;
  isCustomer: boolean;
  error?: boolean;
}

const MessageBubble = ({ isCustomer, children, error }: MessageBubbleProps) => {
  const senderColor = isCustomer ? 'bg-blue-100' : 'bg-neutral-50';
  const bubbleColor = error ? 'bg-red-100' : senderColor;
  const bubbleClass = isCustomer
    ? styles.BorderBottomRight
    : styles.BorderBottomLeft;
  const margin = isCustomer ? 'm-r-6' : styles.AgentMessageBubble;
  return (
    <div
      className={`border-radius-2 p-y-2 p-x-3 ${margin} ${bubbleColor} ${bubbleClass}`}
    >
      {children}
    </div>
  );
};

export default MessageBubble;
